import { render, staticRenderFns } from "./3m.vue?vue&type=template&id=0dc1dd04&scoped=true"
import script from "./3m.vue?vue&type=script&lang=js"
export * from "./3m.vue?vue&type=script&lang=js"
import style0 from "./3m.vue?vue&type=style&index=0&id=0dc1dd04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1dd04",
  null
  
)

export default component.exports